import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex h-150',
    container: 'relative z-2 container flex h-150 items-end lg:justify-end',
    wrap: 'flex flex-col gap-8 pr-3 pb-10 pl-3 md:gap-10 lg:w-122.5 lg:pb-20',
    image: 'size-full object-cover',
    picture: 'absolute top-0 right-0 left-0 h-150',
    logo: 'absolute top-4 right-3 h-auto max-h-20 w-auto lg:top-19.5 lg:max-h-24',
    title: 'md:heading-3xl heading-xl flex-none md:max-w-120 lg:max-w-none',
    video: 'relative z-1 mx-auto h-full w-auto',
    poster: 'absolute size-full object-cover',
    description: 'text-lg font-semibold',
    link: 'inline-flex cursor-pointer items-center gap-5 transition-opacity hover:opacity-70 lg:mb-6',
    linkIconWrap:
      'flex h-20 w-20 items-center justify-center rounded-full bg-white pl-1',
    linkText: 'font-semibold uppercase',
    linkIconTriangle:
      'border-y-8 border-r-0 border-l-8 border-solid border-y-transparent border-l-black',
    closeButton:
      'flex size-10 cursor-pointer items-center justify-center rounded-full bg-white',
    closeIcon: 'size-6 text-black'
  },
  variants: {
    mode: {
      light: {
        title: 'text-white',
        linkText: 'text-white',
        description: 'text-white'
      },
      dark: {
        title: 'text-black',
        linkText: 'text-black',
        description: 'text-black'
      }
    }
  }
});
